// Periods for crypto price history charts (matching React Native structure)

export interface Period {
  id: string
  period: string
}

export const periods: Period[] = [
  { id: 'f0e5d1a9-84d3-4b62-9d13-caf8d5e158ed', period: 'day' },
  { id: 'c2561bfa-22f3-4c9a-9b50-f7a14f298542', period: 'week' },
  { id: 'a4d61699-cf6f-472b-b1ca-17a8ff3b9809', period: 'month' },
  { id: '6cc7db89-1849-42c1-b722-870d72f5a0c6', period: 'year' },
]
